import { Tooltip, Typography } from '@mui/material';
import React from 'react';
export function renderOriginalLocationColumn(t) {
    return {
        sortKey: 'path',
        headerLabel: t('documentPanel.originalLocation'),
        cellFunction: (row) => {
            const originalLocation = ('File Library/' + row.columns.path).replace(/\/[^\/]*$/, '');
            return (React.createElement(Tooltip, { title: originalLocation, placement: 'bottom-start' },
                React.createElement(Typography, { sx: {
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                    } }, originalLocation)));
        },
        tableCellSx: {
            display: {
                xs: 'none',
                sm: 'table-cell',
            },
        },
    };
}
